var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsMoreDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.75V10.5H8.25V12H0V3.75H1.5ZM5.25 0V6.75H12V8.25H3.75V0H5.25Z",
    fill: "#2E3944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMoreDown);
export default __webpack_public_path__ + "static/media/icons_more_down.f9d5e356.svg";
export { ForwardRef as ReactComponent };